exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clmGuidance .textRow {\n  margin-bottom: 0.2em;\n  margin-right: 17px; }\n\n.clmGuidance .textSection {\n  margin-bottom: 2.0em; }\n\n.clmGuidance .textSection .subTitle {\n    margin-bottom: 0.5em;\n    font-weight: bold; }\n\n.clmGuidance .boldText {\n  font-weight: 900; }\n\n.clmGuidance .mainTitle {\n  margin-top: 1em;\n  margin-bottom: 1em; }\n\n.clmGuidance .contentDiv {\n  font-size: 1.5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/clm-guidance/clm-guidance.component.scss
// module id = ../../../../../src/app/components/claim/clm-guidance/clm-guidance.component.scss
// module chunks = main